import urlConfig from "../../config.json";
import { BACKEND_URL } from "../../constants";
import { axios } from "../../utils/axiosConfig";

export const getAssignedTasks = async () => {
  const ROUTE = urlConfig.backend.routes.tasks.getAssignedTasks;
  const url = `${BACKEND_URL}${ROUTE}`;

  return await axios
    .get(url)
    .then((res) => {
      if (res.status === 200) {
        return { res: res.data, error_code: 1 };
      }
      return {
        error_code: 2,
        error_message: "Something went wrong. Please try again later.",
      };
    })
    .catch((error) => {
      const status = error.response?.status;
      const data = error.response?.data;
      if (status === 422) {
        const list = Array.isArray(data?.data) ? data.data : [];
        return { res: { data: list }, error_code: 1 };
      }
      if (status === 400) {
        return {
          error_code: 3,
          error_message:
            typeof data?.message === "string"
              ? data.message
              : "Something went wrong. Please try again later.",
        };
      }
      return {
        error_code: 3,
        error_message:
          typeof data?.message === "string"
            ? data.message
            : error.message || "Request failed",
      };
    });
};
